import { varAlpha } from '../styles';
import COLORS from './colors.json';

// ----------------------------------------------------------------------

export function createShadowColor(colorChannel) {
  return `0 8px 16px 0 ${varAlpha(colorChannel, 0.24)}`;
}

export function customShadows(colorScheme) {
  const colors = COLORS[colorScheme] || COLORS.light;
  const colorChannel = colorScheme === 'light' 
    ? (colors.grey['500Channel'] || colors.grey[500]) 
    : (colors.common.blackChannel || colors.common.black);

  return {
    z1: `0 1px 2px 0 ${varAlpha(colorChannel, 0.16)}`,
    z4: `0 4px 8px 0 ${varAlpha(colorChannel, 0.16)}`,
    z8: `0 8px 16px 0 ${varAlpha(colorChannel, 0.16)}`,
    z12: `0 12px 24px -4px ${varAlpha(colorChannel, 0.16)}`,
    z16: `0 16px 32px -4px ${varAlpha(colorChannel, 0.16)}`,
    z20: `0 20px 40px -4px ${varAlpha(colorChannel, 0.16)}`,
    z24: `0 24px 48px 0 ${varAlpha(colorChannel, 0.16)}`,
    //
    dialog: `-40px 40px 80px -8px ${varAlpha(colors.common.blackChannel || colors.common.black, 0.24)}`,
    card: `0 0 2px 0 ${varAlpha(
      colorChannel,
      0.2
    )}, 0 12px 24px -4px ${varAlpha(colorChannel, 0.12)}`,
    dropdown: `0 0 2px 0 ${varAlpha(
      colorChannel,
      0.24
    )}, 0 12px 32px -4px ${varAlpha(colorChannel, 0.24)}`,
    //
    primary: createShadowColor(colors.primary.mainChannel || colors.primary.main),
    secondary: createShadowColor(colors.secondary.mainChannel || colors.secondary.main),
    info: createShadowColor(colors.info.mainChannel || colors.info.main),
    success: createShadowColor(colors.success.mainChannel || colors.success.main),
    warning: createShadowColor(colors.warning.mainChannel || colors.warning.main),
    error: createShadowColor(colors.error.mainChannel || colors.error.main),
  };
}
